import React from "react";
import { useEffect, useState } from "react";
import "./styles.scss";
import { applyActionCode } from "firebase/auth";
import VerificationScreen from "../VerificationScreen/VerificationScreen";
import { auth } from "../../firebase";
import ErrorScreen from "../ErrorScreen/ErrorScreen";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";

function ActionVerifyEmail({ searchParams }) {
  const navigate = useNavigate();
  const actionCode = searchParams.get("oobCode");
  // const continueUrl = searchParams.get("continueUrl");
  // const lang = searchParams.get("lang");
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
  //  const auth = getAuth(app);
    const fetchData = async () => {
      applyActionCode(auth, actionCode)
        .then((resp) => {
          // TODO: Display a confirmation message to the user.
          // You could also provide the user with a link back to the app.
          // console.log("Response:", resp);
          setShowError(false);
          setIsLoading(false);
          const mobileUrl = "https://go.peeq.inc/signIn/";
         // const desktopUrl = "/";

          setTimeout(() => {
            if (isMobile) {
              window.location.href = mobileUrl;
            } else {
            //   navigate(desktopUrl);
            window.location.href = 'https://admin.peeq.inc/';
            }
          }, 4000);

          // TODO: If a continue URL is available, display a button which on
        })
        .catch((error) => {
          // Code is invalid or expired. Ask the user to verify their email address
          // again.
          setShowError(true);
          setIsLoading(false);
        });
    };

    fetchData();
  }, [actionCode, navigate]);
  return (
    <div className="email-verify-section flex justify-center items-center">
      {isLoading ? (
        <p className="m-auto">Loading...</p>
      ) : (
        <>
          {showError === false ? (
            <VerificationScreen text={"Email Verified"} />
          ) : (
            <ErrorScreen text={"Couldn't verify email"} />
          )}
        </>
      )}
    </div>
  );
}

export default ActionVerifyEmail;
